export default __webpack_public_path__ + "assets/mealkit/mealkit.8ac612034995c205087ff452d503d41d.webp";